module.exports = __webpack_public_path__ + "static/media/default-img-listing.ae3e4955.jpg";